import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Tv2: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M7 21h10' }],
    ['rect', { width: '20', height: '14', x: '2', y: '3', rx: '2' }],
  ],
];

export default Tv2;
